export const NO_TO_TRY = 'NO_TO_TRY'
export const NO_TO_ALL = 'NO_TO_ALL'
export const TRY_TO_NO = 'TRY_TO_NO'
export const TRY_TO_ALL = 'TRY_TO_ALL'

export const RIGHT_MAP = {
  0: {
    name: '无权益',
    color: ''
  },
  1: {
    name: '体验权益',
    color: '#FF5C5C'
  },
  2: {
    name: '小初全科权益',
    color: '#06C270'
  }
}